import { motion } from 'framer-motion';

const JobDetails = () => {
  const jobData = [
    { label: '職種', value: '訪問介護員（ホームヘルパー）' },
    { label: '雇用形態', value: '正社員・パート・アルバイト' },
    { label: '勤務地', value: '岡山市北区○○町1-2-3（訪問先は岡山市北区内）' },
    { label: '給与', value: '正社員：月給20万円〜28万円\nパート：時給1,200円〜1,500円' },
    { label: '勤務時間', value: '9:00〜18:00（シフト制）\n※早朝・夜間勤務可能な方歓迎' },
    { label: '休日休暇', value: '週休2日制（シフト制）\n年次有給休暇、夏季休暇、年末年始休暇' },
    { label: '待遇・福利厚生', value: '社会保険完備、交通費支給、資格取得支援制度、\n制服貸与、定期健康診断、退職金制度（正社員）' },
    { label: '応募資格', value: '介護福祉士、ヘルパー2級以上の資格をお持ちの方\n※未経験者も歓迎（資格取得支援あり）' },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12 sm:mb-16"
        >
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-navy-800 mb-3 sm:mb-4 px-4">
            募集要項
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-navy-700 px-4">
            岡山市北区で訪問介護スタッフを募集しています
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-beige-50 rounded-2xl p-6 sm:p-8 lg:p-10 mb-10 sm:mb-12"
        >
          <div className="space-y-4 sm:space-y-6">
            {jobData.map((item, index) => (
              <div
                key={index}
                className="flex flex-col sm:flex-row sm:items-start border-b border-beige-200 pb-4 sm:pb-6 last:border-b-0 last:pb-0"
              >
                <div className="w-full sm:w-48 font-bold text-navy-800 mb-2 sm:mb-0 flex-shrink-0 text-sm sm:text-base">
                  {item.label}
                </div>
                <div className="flex-1 text-navy-700 whitespace-pre-line text-sm sm:text-base break-words">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="bg-coral-500 rounded-2xl p-6 sm:p-8 text-center"
        >
          <h3 className="text-xl sm:text-2xl font-bold text-white mb-4 sm:mb-6 px-4">
            応募方法
          </h3>
          <p className="text-sm sm:text-base text-white/95 mb-6 sm:mb-8 leading-relaxed px-4">
            まずはお気軽にお電話ください。面接日時などを調整させていただきます。履歴書・職務経歴書をご持参ください。
          </p>
          <a
            href="tel:086-012-3456"
            className="inline-flex items-center space-x-2 bg-white text-coral-600 px-6 sm:px-8 py-3 sm:py-4 rounded-full hover:bg-beige-50 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer text-sm sm:text-base font-medium"
          >
            <i className="ri-phone-line text-lg sm:text-xl"></i>
            <span>086-012-3456</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default JobDetails;
